<template>
    <TemplateNewsID :data="data" />
</template>

<script setup lang="ts">
const route = useRoute();
const newsId = route.params.id;
const { fetchPost } = useFetchAPI();
const { setPostMeta } = useMeta();
const { data } = await fetchPost("news", newsId);

await setPostMeta(data.value, "news");
</script>
